import React from "react";

export const legalCopy = {
  "en-GB":
    "Shopping at members price automatically adds a free 60-Day Free Trial to your basket. This autorenews onto an annual £59 Beauty Pie membership. Cancel any time in your account.",
  "en-US": (
    <p>
      Shopping at members price automatically adds a free 60-Day Free Trial to
      your basket. This <b>autorenews</b> onto an annual $59 Beauty Pie
      membership. <b>Cancel any time</b> in your account.
    </p>
  )
};

export const footerCopy =
  "Prefer to shop at non-members' prices? - Simply click into the product page.";
